var exports = {
  "SW": "PopoverPopout.module__popout___WXJTSm",
  "v3": "PopoverPopout.module__popouts___WXJTSm",
  "tB": "PopoverPopout.module__backdrop___WXJTSm",
  "IM": "PopoverPopout.module__triggerWrapper___WXJTSm",
};

module.exports = exports;
